import React from 'react'
import { useDispatch } from 'react-redux'
import { Dispatch } from 'redux'
import { Usecases, Domain, Modules } from '../core'
import EventDetail from '../components/screens/EventDetail'
import { beginCommunication, endCommunication } from '../core/modules/network'
import { UploadStatusEnum } from '../constants/upload-image-status'

export default function EventDetailContainer() {
  type EventDetailEntity = Domain.Event.DetailEntity
  type CheckEventEntiTy = Domain.Event.CheckEventEntiTy

  const eventInitialState = {
    tenantId: '',
    eventId: '',
    eventImageDetail: '',
    headLineText: '',
    eventDescription: '',
    startDate: '',
    endDate: '',
    currentDate: '',
    imageText: '',
    isDisplayUploadImage: false,
    checkRegisterCard: false,
    isDisableDuration: false,
    isDisableIndex: false,
    commentInfos: [],
  }
  
  const checkEventInitialState = {
    eventRegist: false
  }

  const [event, setEvent] = React.useState<EventDetailEntity>(eventInitialState)
  const [checkEvent, setCheckEvent] = React.useState<CheckEventEntiTy>(checkEventInitialState)

  const dispatch = useDispatch()
  const actions = React.useMemo(
    () => ({
      
      fetchEvent (eventId: string) {
        const didCallFetchEventApi = (data: EventDetailEntity) => {
          setEvent(data)
        }
        const reloader = () => {
          dispatch(Usecases.Event.fetchEvent(reloader, eventId, didCallFetchEventApi))
        }
        dispatch(Usecases.Event.fetchEvent(reloader, eventId, didCallFetchEventApi))
      },

      fetchEventEntryStatus (eventId: string) {
        const didCallFetchEventEntryStatus = (data: CheckEventEntiTy) => {
          setCheckEvent(data)
        }
        const reloader = () => {
          dispatch(Usecases.Event.fetchEventEntryStatus(reloader, eventId, didCallFetchEventEntryStatus))
        }
        dispatch(Usecases.Event.fetchEventEntryStatus(reloader, eventId, didCallFetchEventEntryStatus))
      },

      registerEvent(body: Domain.Event.PostEventEntity) {
        const didCallPostEventApi = () => {
          setCheckEvent({eventRegist: true})
        }
        dispatch(Usecases.Event.registerEvent(body, didCallPostEventApi))
      },

      uploadImageAPI(blob: Blob, eventId: string,  setUploadStatus: (status: number) => void, scrollPosition: number) {
        const headers = {
          Authorization: Domain.Auth.getAccessToken(),
          'Content-Type': 'image/jpeg',
        }    
        return async function(reduxDispatch: Dispatch) {
          reduxDispatch(beginCommunication())
          try {
            const response = await fetch(
              `${process.env.REACT_APP_TOKYU_API_ENDPOINT}/user-entry/upload?eventId=${eventId}&tenantId=${process.env.REACT_APP_TENANT_ID}`,
              {
                method: 'POST',
                headers,
                body: blob,
              },
            )

            const apiErrorResponse: Domain.ApiErrorResponse.Entity = await response.json()
            if (response.ok) {
              setUploadStatus(UploadStatusEnum.Done)
            } else {
              dispatch(Modules.ErrorModule.setError(apiErrorResponse))
              return
            }
          }
          catch (e) {
            setUploadStatus(UploadStatusEnum.Failed)
          }
          finally {
            reduxDispatch(endCommunication())
            window.scrollTo(0, scrollPosition)
          }
        }
      }
    }),
    [dispatch],
  )
  return <EventDetail event={event} checkEvent={checkEvent} actions={actions} />
}
